// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"8a226e8c","137":"8a226e8c","232":"8a226e8c"}[chunkId] + ".chunk.css";
};